import { CommonPullupMenuComponent } from './../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { DeleteRoomModalComponent } from './../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import {
  NavController,
  Platform,
  NavParams,
  ActionSheetController,
  ModalController,
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import * as moment from 'moment';
import {
  CompetitionInfo,
  CompetitionDetails,
  createCompetitionDetails,
  FlightInfo,
  Leaderboard,
  createLeaderboardDetails,
  CompetitionPlayerInfo,
  CompetitionTeams,
} from './../../../../data/competition-data';
import { ClubMembership, PlayerInfo } from './../../../../data/player-data';
import { ServerResult } from './../../../../data/server-result';
import {
  GameRoundInfo,
  createGameRoundInfo,
  PlayerHomeInfo,
  PlainScoreCard,
  FlightMember,
  CompetitionRoundCourseRatings,
  LeagueRound,
  CompetitionData,
  GameRoundData,
  CompetitionRoundSession,
  FlightMoreData,
  CompetitionPlayerData,
  CompetitionWaitList,
  LeagueSeason,
  MergedCompetitionDetails,
  CompetitionFeeApplicable,
  CompetitionMatch,
  CompPlayerParticipation,
  CompetitionMatchParticipant,
  CompetitionTeamPlayerData,
} from './../../../../data/mygolf.data';

import { CompetitionService } from './../../../../providers/competition-service/competition-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { AuthenticationService } from 'src/authentication-service';

import { MessageDisplayUtil } from './../../../../message-display-utils';
import { PlayerService } from './../../../../providers/player-service/player-service';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo,
} from './../../../../providers/pushnotification-service/notification-handler-constructs';
import { ScorecardDisplayPage } from './../../scorecard-display/scorecard-display.page';

import { adjustViewZIndex } from 'src/globals';

import { SessionInfo } from './../../../../data/authentication-info';
import { SessionDataService } from './../../../../redux/session/session-data-service';

import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { CurrentScorecardActions, CurrentScorecardDataService } from 'src/redux/scorecard';
import { Observable, Subscription, forkJoin, from, of } from 'rxjs';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';

//

import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { CoursesModalPage } from '../competitions-modal/courses-modal/courses-modal.page';
import { DescriptionModalPage } from '../competitions-modal/description-modal/description-modal.page';
import { FullInfoModalPage } from '../competitions-modal/full-info-modal/full-info-modal.page';
import { RulesModalPage } from '../competitions-modal/rules-modal/rules-modal.page';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ExpandCompetitionLogo } from './competition-details-expand-logo';
import { CompetitionPaymentConfirm } from './competition-payment-confirmation.page';
import { Location } from '@angular/common';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

import * as global from 'src/globals';
import { CompetitionLeagueMenuPage } from '../competition-league-menu/competition-league-menu.page';
import { PaymentSelectionPage } from '../../booking/booking-details/payment-selection/payment-selection.page';
import { CompetitionPaymentSelectionPage } from '../competition-payment-selection/competition-payment-selection.page';
import { resolve } from 'url';
import { SUBSCRIBE_COMP_SHOW_LEADERBOARD, WebsocketActions } from 'src/redux/wstomp';

// import { CompetitionFulDetailsPage } from './competition-full-details';
@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.page.html',
  styleUrls: ['./competition-details.page.scss'],
  providers: [NavParams],
})
export class CompetitionDetailsPage implements OnInit, OnDestroy {
  scorecard: PlainScoreCard;
  competition: MergedCompetitionDetails;
  compId: number;
  details: CompetitionDetails;
  flights: Array<FlightMoreData> = new Array<FlightMoreData>();
  leaderBoard: Leaderboard;
  currentRound: number = 1;
  gameRound: GameRoundInfo;
  countDays: number;
  countDaysText: string;
  countDaysRound: number;
  scoringRound: number = 0;
  freshCompInfo: boolean = true;
  clubName: string;
  memberships: Array<ClubMembership> = [];
  compTeams: CompetitionTeams;
  roundList: Array<number> = [];

  needRefresh: boolean = true;
  session: SessionInfo;

  showTeam: boolean = false;

  currentPlayer: PlayerInfo;

  flightPublished: boolean = true;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  playerIsPlaying: Array<any>;

  isEclectic: boolean = false;

  compData: CompetitionData;
  compSessions: Array<CompetitionRoundSession>;
  fromScorecard: boolean = false;

  constructor(
    private router: Router,
    private modalcontroler: ModalController,
    private loadingCtl: LoadingController,
    private compService: CompetitionService,
    private nav: NavController,
    private navParams: NavParams,
    private platform: Platform,
    private actionSheetCtl: ActionSheetController,
    private alertCtl: AlertController,
    private toastCtl: ToastController,
    private renderer: Renderer2, // private playerHomeService: PlayerHomeDataService
    private modalCtl: ModalController,
    private auth: AuthenticationService,
    private scorecardService: ScorecardService,
    private sessionService: SessionDataService,
    private playerService: PlayerService,

    private playerHomeActions: PlayerHomeActions,
    private currentScorecardActions: CurrentScorecardActions,
    private playerHomeService: PlayerHomeDataService,
    private currentScorecardService: CurrentScorecardDataService,
    private flightService: ClubFlightService,
    private route: ActivatedRoute,
    private location: Location,
    private mg2uUtils: mygolfUtils,
    private websocketActions: WebsocketActions
  ) {
    console.debug(
      'check redirect home',
      this.router.getCurrentNavigation().extras.state,
      this.platform.getQueryParam('compRegister')
    );
    if (
      !this.router.getCurrentNavigation().extras.state &&
      !this.platform.getQueryParam('compRegister')
    ) {
      this.goHome();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.fromScorecard = this.router.getCurrentNavigation().extras.state.fromScoring;
    this.details = createCompetitionDetails();
    this.leaderBoard = createLeaderboardDetails();
    this.gameRound = createGameRoundInfo();
    this.flights = new Array<FlightMoreData>();
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.compData = this.router.getCurrentNavigation().extras.state.compData;
    if (this.competition?.id || this.competition?.competitionId || this.compId) {
      // this.compId = this.competition?.id;
      this.refreshCompData();

      this.getPlayerApplicableFee().then(() => {});
      // let _compId = this.compId;
      // this.flightService.getCompetitionDetails(_compId)
      // .subscribe((compData)=>{
      //   if(compData) this.compData = compData;
      //   this.compService.setCompData(compData);
      //   console.debug("get comp data", compData, this.compData);
      //   this._checkCompetitionSessions();
      // })
    }

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    this.player$ = this.playerHomeInfo$.pipe(filter(Boolean)).pipe(
      map((playerHome: any) => {
        return playerHome;
      })
    );
    if (this.fromScorecard) {
      this.onRefreshClick(null);
    }
    console.debug(
      'view did load ',
      this.fromScorecard,
      this.competition,
      this.compData,
      this.router.getCurrentNavigation().extras.state
    );

    this.initWebsocketActions();
  }
  ngOnInit() {}

  ionViewDidLoad() {}

  ionViewDidEnter() {
    this.sessionService
      .getSession()
      .pipe(take(1))
      .subscribe((session: SessionInfo) => {
        this.session = session;
      });

    adjustViewZIndex(this.nav, this.renderer);
    if (this.needRefresh) {
      this.needRefresh = false;
      this.refreshPage(false);
    }
  }

  ionViewDidLeave() {
    this.compService.clearCompData();
    if (this.subShowLeaderboard) {
      this.subShowLeaderboard.unsubscribe();
      this.subShowLeaderboard = null;
    }
  }

  ionViewWillEnter() {
    let _fromFlight = this.navParams.get('fromFlight');
    if (_fromFlight) this.flightPublished = this.navParams.get('flightPublished');

    if (!this.flightPublished) {
      let subTitle = 'Flights have not been published yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
    }
  }
  async deriveSession() {
    this.session = await this.sessionService.getSession().toPromise();
  }
  refreshPage(pushData: any) {
    this.onRefreshClick(null);
  }

  public getNotifications(): Array<NotificationHandlerInfo> {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_COMP_INFO_CHANGED,
      whenActive: 'showToast',
      needRefresh: true,
    });
    return notifications;
  }

  onRefreshClick(refresher) {
    this.freshCompInfo = true;
    this.goingToPay = false;
    this._refreshCompetitionInfo(refresher);
    this.refreshCompData();
    this.getPlayerApplicableFee().then(() => {});
  }

  private async _refreshCompetitionInfo(refresher, attribute?: string) {
    let loader = await this.loadingCtl.create({
      message: 'Please wait...',
      showBackdrop: true,
      duration: 5000,
    });
    loader.onDidDismiss().then(() => {
      if (refresher) {
        refresher.detail.complete();
      }
    });
    loader.present().then(() => {
      this.compService
        .getCompetitionInfo(this.compId)
        .subscribe((comp: MergedCompetitionDetails) => {
          this.competition = comp;
          // this.flightService
          //   .checkLeagueCompetition(
          //     this.competition ? this.compId : this.compId
          //   )
          //   .subscribe((data) => {
          //     this.isEclectic = data;
          //     if(this.isEclectic) {
          //       this.getLeagueSeason();
          //     }
          //   });
          this._init();
          //Get competition details
          this.compService.getDetails(this.compId).subscribe(
            (details: any) => {
              this.details = details;
              this.getCompRoundCourseRatings();
              //Get the scoring round
              this.compService.getScoringRoundNumber(this.compId).subscribe(
                (roundNo: number) => {
                  this.scoringRound = roundNo;
                  //Get players
                  this.compService.getPlayersRegistered(this.compId).subscribe(
                    (players: any) => {
                      this.details.players = players;
                      let _player;
                      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
                        if (player) _player = player;
                      });

                      this.playerIsPlaying = this.details.players.filter(
                        (compPlayer: CompetitionPlayerInfo) => {
                          if (compPlayer && compPlayer.playerId && _player && _player.playerId) {
                            return compPlayer.playerId === _player.playerId;
                          } else return false;
                        }
                      );

                      this.competition.totalRegistered = this.details.players.length;
                      this.compService.getCompetitionTeams(this.compId).subscribe(
                        (compTeams: any) => {
                          console.debug('get comp teams : ', compTeams);
                          this.compTeams = compTeams;
                          if (this.currentRound == null) {
                            this.currentRound = this.details.roundInProgress;
                            if (!this.currentRound) this.currentRound = this.details.nextRound;
                          }

                          if (this.currentRound != null) {
                            // this.compService
                            //   .getFlights(
                            this.flightService
                              .getCompFlightList(this.compId, this.currentRound)
                              .subscribe(
                                (flights: any) => {
                                  this.flights = flights;

                                  loader.dismiss().then(() => {
                                    this._onRefreshComplete();
                                    if (attribute === 'refreshFlight') {
                                      this.goFlights(attribute);
                                    }
                                  });
                                },
                                error => {
                                  loader.dismiss();
                                }
                              );
                          } else {
                            loader.dismiss();
                            adjustViewZIndex(this.nav, this.renderer);
                          }
                        },
                        error => {
                          //Error getting comp teams
                          loader.dismiss().then(() => {
                            this._onRefreshComplete();
                          });
                        }
                      );
                    },
                    error => {
                      //Error getting comp players
                      loader.dismiss().then(() => {
                        this._onRefreshComplete();
                      });
                    }
                  );
                },
                error => {
                  //Error getting scoring round
                  this.scoringRound = 0;
                  loader.dismiss(() => {
                    this._onRefreshComplete();
                    let msg = MessageDisplayUtil.getErrorMessage(
                      error,
                      'Error getting scoring round'
                    );
                    // MessageDisplayUtil.showErrorToast(
                    //   msg,
                    //   this.platform,
                    //   this.toastCtl,
                    //   3000,
                    //   'bottom'
                    // );
                    this.onErrorMessage('Scorecard', 'Error getting scoring round');
                  });
                }
              );
            },
            error => {
              loader.dismiss(() => {
                this._onRefreshComplete();
                let msg = MessageDisplayUtil.getErrorMessage(
                  error,
                  'Error getting competition details'
                );
                // MessageDisplayUtil.showErrorToast(
                //   msg,
                //   this.platform,
                //   this.toastCtl,
                //   3000,
                //   'bottom'
                // );
                this.onErrorMessage('Competition', 'Error getting competition details');
              });
            }
          );

          // this.doRefresh(refresher, loader);
        }),
        error => {
          loader.dismiss().then(() => {
            this._onRefreshComplete();
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error getting competition information'
            );
            // MessageDisplayUtil.showErrorToast(
            //   msg,
            //   this.platform,
            //   this.toastCtl,
            //   3000,
            //   'bottom'
            // );
            this.onErrorMessage('Competition', 'Error getting competition information');
          });
        },
        () => {};
    });
  }

  private _onRefreshComplete() {
    if (this.freshCompInfo) {
      // if (this.currentRound == null) {
      if (this.competition.status == 'Completed') {
        this.currentRound = this.competition.totalRounds;
      } else {
        this.currentRound = this.details.roundInProgress;
        if (!this.currentRound) this.currentRound = this.details.nextRound;
        if (!this.currentRound) this.currentRound = 1;
      }
    }
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => {
        return gr.roundNo == this.currentRound;
      })
      .pop();
    this.roundList = [];

    for (let i = 1; i <= this.competition.totalRounds; i++) {
      this.roundList.push(i);
    }

    adjustViewZIndex(this.nav, this.renderer);

    // this.getPlayerInfo();
  }

  private refreshPlayers() {
    this.compService.getPlayersRegistered(this.compId).subscribe((players: any) => {
      this.details.players = players;
      this.competition.totalRegistered = this.details.players.length;
    });
  }

  private _init() {
    var b = moment();
    var a = moment(this.competition.startDate);

    this.countDays = a.diff(b, 'days', true) + 1;
    this.countDays = Math.round(this.countDays * 100) / 100;
    this.countDaysRound = a.diff(b, 'days') + 1; // =1

    if (this.countDays >= 0.0 && this.countDays <= 0.99) {
      this.countDaysText = 'Starts today';
    }
    if (this.countDays < 0) {
      this.countDaysText = 'Not started yet';
    }
    if (this.countDays >= 1.0 && this.countDays <= 1.99) {
      this.countDaysText = 'Starts tomorrow ';
    }
    if (this.countDays >= 2) {
      this.countDaysText = 'Starts in ' + this.countDaysRound + ' days';
    }
  }

  public roundNoToDisplay(): string {
    if (this.details && this.details.roundInProgress) return 'R' + this.details.roundInProgress;
    else if (this.details && this.details.nextRound) return 'R' + this.details.nextRound;
    else return 'R1';
  }

  async openMenu() {
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {},
        },
      ],
    });

    let roundNo = this.competition.totalRounds;
    for (let i = 1; i <= roundNo; i++) {
      actionSheet.buttons.push({
        text: 'Round ' + i,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          this.currentRound = i;
          //  this.roundInfo = this.getSelectedRoundInfo();
          //this.doRefresh(null);
          //+ this.roundInfo.id
          this.gameRound = this.details.gameRounds
            .filter((gr: GameRoundInfo) => {
              return gr.roundNo == this.currentRound;
            })
            .pop();
          this.freshCompInfo = false;
          this._refreshCompetitionInfo(null);

          //  this.goScorecard();
        },
      });
    }

    actionSheet.present();
  }

  checkBtnRegister() {
    if (this.compData?.waitListSize > 0 && this.isWaitListed()) return false;
    // console.debug("check btn REGISTER", this.competition)
    if (
      this.competition.status != 'Completed' &&
      !this.isClosedForRegistration() &&
      !this.isRegistered()
    )
      return true;
    // this.competition.closedForRegistration == false
  }

  checkBtnDeRegister() {
    if (this.compData?.waitListSize > 0 && this.isWaitListed()) return true;
    // console.debug("check btn DE-REGISTER", this.competition)
    if (
      this.competition.status != 'Completed' &&
      this.competition.status != 'In Progress' &&
      !this.isClosedForRegistration() &&
      this.isRegistered()
    )
      return true;

    // this.competition.closedForRegistration === false
  }

  getSelectedRoundInfo() {
    return this.details.gameRounds
      .filter((gr: GameRoundInfo) => {
        return gr.roundNo == this.currentRound;
      })
      .pop();
  }

  async CompetitionDetailsModal() {
    let modal = await this.modalCtl.create({
      component: FullInfoModalPage,
      componentProps: { competition: this.competition, compId: this.compId },
    });
    modal.present();
  }

  getPlayerInFlight() {
    if (!this.flights) return;
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight;

    _playerInFlight = this.flights.filter((flight: FlightMoreData) => {
      // return flight.playerFlight;
      let _playerFlight = flight.flightMembers.filter(flightMember => {
        return flightMember?.player?.playerId === _player?.playerId;
      });
      if (_playerFlight?.length > 0) flight.playerFlight = true;
      return _playerFlight;
    });

    // console.debug("get player in flight", _playerInFlight, _player, this.flights);

    if ((_playerInFlight && _playerInFlight.length === 0) || !_playerInFlight) {
      return false;
    } else return true;
  }

  async goScorecard() {
    let loader = await this.loadingCtl.create({
      message: 'Getting scorecard. Please wait...',
    });
    if (this.competition.status == 'Upcoming') {
      let subTitle = 'Competition has not started';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onShowMessage('Info', subTitle);
      return false;
    }

    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight;
    _playerInFlight = this.flights.filter((flight: FlightMoreData) => {
      return flight.playerFlight;
    });
    // this.flights.filter((flight)=>{
    //   _playerInFlight = flight.flightMembers.filter((flightMember)=>{
    //     return flightMember.playerId === _player.playerId
    //   })
    // });

    // if(_playerInFlight && _playerInFlight.length === 0 || !_playerInFlight) {
    if (!this.getPlayerInFlight()) {
      let _msg = 'You are not playing in this round.';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      this.onErrorMessage('Scorecard', _msg);
      return false;
    }

    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => {
        return gr.roundNo == this.currentRound;
      })
      .pop();

    loader.present().then(() => {
      this.scorecardService.getScorecard(this.gameRound.id).subscribe(
        (scorecard: PlainScoreCard) => {
          loader.dismiss().then(() => {
            this.scorecard = scorecard;
            let _player: PlayerInfo;
            this.player$.pipe(take(1)).subscribe(player => {
              _player = player;
            });
            if (this.scorecard.success) {
            }

            let navigationExtras: NavigationExtras = {
              state: {
                scorecard: this.scorecard,
                competition: this.competition,
                compId: this.compId,
                gameRound: this.gameRound,
                isCompetition: true,
                editing: true,
                currentPlayer: _player,
              },
            };
            this.router.navigate(['scorecard-display'], navigationExtras);
          });
        },
        error => {
          //let title = "No Sponsors";
          console.debug('getting scorecard : ', error?.error);
          if (loader) loader.dismiss();

          let _error;
          let subTitle;
          // if(error?.error?.json()) {
          //   _error = error.json();
          //   subTitle = _error.message;
          // } else
          subTitle = error?.error?.message;
          // MessageDisplayUtil.displayErrorAlert(
          //   this.alertCtl,
          //   '',
          //   subTitle,
          //   'OK'
          // );

          this.onErrorMessage('Flights', subTitle);
        },
        () => {
          //if (isPresent(this.gameRound)) {
        }
      );
    });
    //if(this.scorecard.success){

    //            this.nav.push(ScorecardPage, {

    /*	} else {
     let title = "No Sponsors";
     let subTitle = this.scorecard.message;
     MessageDisplayUtil.displayInfoAlert(this.alertCtl, "", subTitle, "OK");
     }
     */
  }

  async initPageLoader(message: string = '') {
    this.pageLoader = await this.loadingCtl.create({
      cssClass: 'custom-loading',
      message: message,
      backdropDismiss: false,
      // duration: 3000,
      showBackdrop: true,
    });
  }

  compScoringClicked: boolean = false;
  pageLoader: HTMLIonLoadingElement | null = null; // any;
  async onCompetitionScoringClick() {
    if (this.compScoringClicked) return;
    this.compScoringClicked = true;
    await this.initPageLoader('Getting scorecard. Please wait...');
    console.debug(
      'on comp scoring click',
      this.currentRound,
      this.details,
      this.competition,
      this.gameRound,
      this.getPlayerStatus()
    );
    if (!this.currentRound) return;
    if (!this.competition) return;
    if (this.competition && !this.compId) return;
    if (this.getPlayerStatus() === 'Withdrawn') {
      let _msg = 'You have Withdrawn from the competition. Please go to View Scorecard instead';
      this.onShowMessage('Scorecard', _msg);
      return false;
    }

    // let loader = await this.loadingCtl.create({
    //   message: "Getting scorecard. Please wait...",
    //   backdropDismiss: false
    // });
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _competitionId;
    let _isScorer;
    // this.scorecardService.clearScorecard().subscribe((scorecard)=>{

    // });

    let _today = moment().format('YYYY-MM-DD');
    let _startDate = moment(this.competition.startDate).format('YYYY-MM-DD');
    let _endDate = moment(this.competition.endDate).format('YYYY-MM-DD');

    if (_startDate > _today && _endDate < _today) {
      let _msg = 'Competition is not active anymore';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );

      console.debug('on comp scoring [1] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    } else if (_endDate < _today) {
      let _msg = 'Competition is not active anymore';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      console.debug('on comp scoring [2] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    }

    // this.flights.filter((flight)=>{

    //   flight.flightMembers.filter((flightMember)=>{
    //     flightMember.playerId === return
    //   })
    // })
    // if(loader) loader.present();
    this.compService.getScorers(this.compId, this.currentRound).subscribe(data => {
      if (data) {
        let _playerInFlight;
        // this.compService
        //   .getFlights(
        this.flightService
          .getCompFlightList(this.compId, this.currentRound)
          .subscribe((flights: any) => {
            flights.filter(flight => {
              _playerInFlight = flight.flightMembers.filter(flightMember => {
                return flightMember?.player?.playerId === _player.playerId;
              });
            });
          });
        // if(_playerInFlight && _playerInFlight.length === 0 || !_playerInFlight) {
        if (!this.getPlayerInFlight()) {
          let _msg = 'You are not playing in this round.';
          // MessageDisplayUtil.showErrorToast(
          //   _msg,
          //   this.platform,
          //   this.toastCtl,
          //   3000,
          //   'bottom'
          // );
          this.onErrorMessage('Scorecard', _msg);
          return false;
        }
        _isScorer = data.filter(data => {
          return data.playerId === _player.playerId;
        });

        this.pageLoader.present();
        setTimeout(() => {
          if (this.playerIsPlaying && this.playerIsPlaying.length > 0) {
            this.scorecardService.getCurrentScorecard().subscribe(
              async (scorecard: PlainScoreCard) => {
                if ((scorecard && scorecard.competitionId !== this.compId) || !scorecard) {
                  if ((_isScorer && _isScorer.length === 0) || !_isScorer) {
                    this.scorecardService
                      .getScorecard(this.details.gameRounds[this.currentRound - 1].id)
                      .subscribe(
                        (scorecard: PlainScoreCard) => {
                          // if (loader) loader.dismiss();
                          let navigationExtras: NavigationExtras = {
                            state: {
                              scorecard: scorecard,
                              competition: this.competition,
                              compId: this.compId,
                              currentPlayer: _player,
                              editingScorecard: _isScorer && _isScorer.length > 0 ? true : false,
                            },
                          };
                          this.router
                            .navigate(['gameround-scoring'], navigationExtras)
                            .then(async () => {
                              await this.router.events.subscribe(async event => {
                                console.debug(
                                  'trying to dismiss : ',
                                  event,
                                  event instanceof NavigationEnd
                                );
                                if (event instanceof NavigationEnd) {
                                  this.compScoringClicked = false;
                                  // if (this.pageLoader)
                                  await this.pageLoader.dismiss();
                                }
                              });
                            });
                        },
                        error => {
                          let _error = error.json();

                          let _msg = _error.message;
                          // MessageDisplayUtil.showErrorToast(
                          //   _msg,
                          //   this.platform,
                          //   this.toastCtl,
                          //   3000,
                          //   'bottom'
                          // );
                          this.onErrorMessage('Scorecard', _msg);
                          return false;
                        }
                      );
                  } else if (_isScorer && _isScorer.length > 0) {
                    let loader = await this.loadingCtl.create({
                      message: 'Getting scorecard. Please wait...',
                    });
                    loader.present().then(() => {
                      let _getCompetitionScoring = this.playerHomeActions.getCompetitionScoring(
                        this.compId,
                        _player.playerId,
                        loader
                      );

                      let getScorecard = setInterval(() => {
                        this.scorecardService.getCurrentScorecard().subscribe(
                          (scorecard: PlainScoreCard) => {
                            if (scorecard && scorecard.competitionId === this.compId) {
                              clearInterval(getScorecard);
                              this.compService.getCompetitionInfo(this.compId).subscribe(
                                (comp: MergedCompetitionDetails) => {
                                  loader.dismiss().then(() => {
                                    this.currentScorecardActions.setScoringPlayer(_player.playerId);
                                    let navigationExtras: NavigationExtras = {
                                      state: {
                                        scorecard: scorecard,
                                        competition: comp,
                                        currentPlayer: _player,
                                      },
                                    };
                                    this.router
                                      .navigate(['gameround-scoring'], navigationExtras)
                                      .then(async () => {
                                        await this.router.events.subscribe(async event => {
                                          console.debug(
                                            'trying to dismiss : ',
                                            event,
                                            event instanceof NavigationEnd
                                          );
                                          if (event instanceof NavigationEnd) {
                                            this.compScoringClicked = false;
                                            // if (this.pageLoader)
                                            await this.pageLoader.dismiss();
                                          }
                                        });
                                      });
                                  });
                                },
                                error => {
                                  if (loader) loader.dismiss();
                                  clearInterval(getScorecard);
                                },
                                () => {
                                  // if(loader) loader.dismiss();
                                }
                              );
                            }
                          },
                          error => {
                            if (loader) loader.dismiss();
                            this.scorecardService
                              .getScorecard(this.details.gameRounds[this.currentRound - 1].id)
                              .subscribe(
                                (scorecardNon: PlainScoreCard) => {
                                  let navigationExtras: NavigationExtras = {
                                    state: {
                                      scorecard: scorecardNon,
                                      competition: this.competition,
                                      compId: this.compId,
                                      currentPlayer: _player,
                                      editingScorecard: false,
                                    },
                                  };
                                  this.router
                                    .navigate(['gameround-scoring'], navigationExtras)
                                    .then(async () => {
                                      await this.router.events.subscribe(async event => {
                                        console.debug(
                                          'trying to dismiss : ',
                                          event,
                                          event instanceof NavigationEnd
                                        );
                                        if (event instanceof NavigationEnd) {
                                          this.compScoringClicked = false;
                                          // if (this.pageLoader)
                                          await this.pageLoader.dismiss();
                                        }
                                      });
                                    });
                                  //
                                },
                                error => {
                                  if (loader) loader.dismiss();
                                  let _error = error.json();

                                  let _msg = _error.message;
                                  // MessageDisplayUtil.showErrorToast(
                                  //   _msg,
                                  //   this.platform,
                                  //   this.toastCtl,
                                  //   3000,
                                  //   'bottom'
                                  // );
                                  this.onErrorMessage('Scorecard', _msg);
                                  return false;
                                }
                              );
                          },
                          () => {
                            //  clearInterval(getScorecard)
                          }
                        );
                      }, 3000);
                    });
                  }
                } else {
                  // if (loader) loader.dismiss();
                  if (scorecard) _competitionId = scorecard.competitionId;
                  else _competitionId = this.compId ? this.compId : this.compId;
                  this.compService
                    .getCompetitionInfo(_competitionId)
                    .subscribe((comp: MergedCompetitionDetails) => {
                      this.playerService
                        .getPlayerInfo(this.session.playerId)
                        .subscribe(async (player: PlayerInfo) => {
                          if (scorecard) {
                            let navigationExtras: NavigationExtras = {
                              state: {
                                scorecard: scorecard,
                                competition: comp,
                                currentPlayer: player,
                              },
                            };
                            this.router
                              .navigate(['gameround-scoring'], navigationExtras)
                              .then(async () => {
                                await this.router.events.subscribe(async event => {
                                  console.debug(
                                    'trying to dismiss : ',
                                    event,
                                    event instanceof NavigationEnd
                                  );
                                  if (event instanceof NavigationEnd) {
                                    this.compScoringClicked = false;
                                    // if (this.pageLoader)
                                    await this.pageLoader.dismiss();
                                  }
                                });
                              });
                          } else {
                            let loader = await this.loadingCtl.create({
                              message: 'Getting scorecard. Please wait...',
                            });

                            let _compId;
                            // this.playerHomeInfo$.filter(Boolean).subscribe((a: PlayerHomeInfo)=>{
                            //     if(a.compsActiveToday && a.compsActiveToday.length > 0)
                            //     _compId = a.compsActiveToday[0].competitionId
                            // });
                            _compId = this.compId;
                            this.playerHomeActions.getCompetitionScoring(
                              _compId,
                              this.session.playerId,
                              loader
                            );
                            let getScorecard = setInterval(() => {
                              this.scorecardService
                                .getCurrentScorecard()
                                .subscribe((scorecard: PlainScoreCard) => {
                                  if (scorecard) {
                                    clearInterval(getScorecard);
                                    this.compService.getCompetitionInfo(_compId).subscribe(
                                      (comp: MergedCompetitionDetails) => {
                                        // loader.dismiss().then(() => {
                                        this.currentScorecardActions.setScoringPlayer(
                                          this.session.playerId
                                        );

                                        let navigationExtras: NavigationExtras = {
                                          state: {
                                            scorecard: scorecard,
                                            competition: comp,
                                            currentPlayer: _player,
                                          },
                                        };
                                        this.router
                                          .navigate(['gameround-scoring'], navigationExtras)
                                          .then(async () => {
                                            await this.router.events.subscribe(async event => {
                                              console.debug(
                                                'trying to dismiss : ',
                                                event,
                                                event instanceof NavigationEnd
                                              );
                                              if (event instanceof NavigationEnd) {
                                                this.compScoringClicked = false;
                                                // if (this.pageLoader)
                                                await this.pageLoader.dismiss();
                                              }
                                            });
                                          });

                                        // });
                                      },
                                      error => {
                                        if (loader) loader.dismiss();
                                        clearInterval(getScorecard);
                                      },
                                      () => {
                                        if (loader) loader.dismiss();
                                      }
                                    );
                                  }
                                });
                            }, 1000);
                          }
                        });
                    });
                }
              },
              error => {}
            );
          }
        }, 1000);
      }
    });

    // if(1) return;

    // if (this.scoringRound > 0) {
  }

  goSponsors() {
    if (this.details.sponsors.length < 1) {
      // let subTitle = 'No sponsors have been defined for this competition'; //'Sponsors have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Sponsors', 'No sponsors have been defined for this competition');
    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          sponsors: this.compData?.sponsors, // || this.details.sponsors,
        },
      };
      this.router.navigate(['tabs/competition-sponsors'], navigationExtras);
    }
  }

  goPrizes() {
    if (this.prizeCount() < 1) {
      let subTitle = 'No Prizes have been defined for this competition'; //'Prizes have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Prizes', subTitle);
    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          prizes: this.details.prizes,
          teamPrizes: this.details.teamPrizes,
          categories: this.details.categories,
        },
      };
      this.router.navigate(['tabs/competition-prizes'], navigationExtras);
    }
  }
  toggleTeamEvent(type) {
    if (type == 'individual') {
      this.showTeam = false;
    } else if (type == 'team') {
      this.showTeam = true;
    }

    this.goLeaderboard();
  }
  // goTeamLeaderboard(){
  //   this.showTeam = true;
  //
  //   this.goLeaderboard();
  // }

  ngOnDestroy() {
    this.ionViewWillLeave();
  }
  ionViewWillLeave() {
    if (this.pageLoader) {
      this.pageLoader.dismiss();
    }
  }
  goLeaderboard() {
    // this._refreshCompetitionInfo(null);
    if (this.competition.status == 'Upcoming' || this.competition.status == 'Not Started') {
      // let subTitle =
      //   'Competition has not started. Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        '',
        'Competition has not started. Please refresh to view latest competition status.'
      );
      return false;
    }
    if (!this.competition.showLeaderBoard) {
      // let subTitle =
      //   'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        'Leaderboard',
        'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.'
      );
      return false;
    }
    if (this.currentRound == null) {
      this.currentRound = this.details.roundInProgress;
      if (!this.currentRound) this.currentRound = this.details.nextRound;
    }
    if (this.currentRound != null) {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          leaderboards: this.leaderBoard,
          leaderboardPlayers: this.leaderBoard.players,
          roundNo: this.currentRound,
          categories: this.details.categories,
          teams: this.competition.teamEvent ? null : null,
          showTeam: this.showTeam,
          compData: this.compData,
        },
      };
      this.router.navigate(['tabs/competition-leaderboard'], navigationExtras);
    }
  }

  goPlayers() {
    if (this.details.players.length < 1) {
      let subTitle = 'Players have not registered for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Players', subTitle);
    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          players: this.details.players,
          roundNo: this.currentRound,
          categories: this.details.categories,
        },
      };
      this.router.navigate(['tabs/competition-players'], navigationExtras);
    }
  }

  async onImageClick() {
    let modal = await this.modalCtl.create({
      component: ExpandCompetitionLogo,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        competition: this.competition,
        compId: this.compId,
      },
    });
    await modal.present();
  }
  goFlights(attribute?: string) {
    if (this.gameRound.status === 'Pending' && !attribute) {
      this._refreshCompetitionInfo(null, 'refreshFlight');
      return false;
    }

    if (this.gameRound && this.gameRound.status === 'Pending' && !this.gameRound.publishFlights) {
      let _multipleRounds = false;
      if (this.competition && this.competition.totalRounds > 1) _multipleRounds = true;

      let subTitle;
      if (_multipleRounds)
        subTitle = 'Flights for round ' + this.gameRound.roundNo + ' have not been published yet.';
      //'Flights have not been defined for this competition yet';
      else if (!_multipleRounds) subTitle = 'Flights have not been published yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
      return false;
    }
    if (this.flights.length < 1) {
      let subTitle = 'No flights have been defined for this round'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
      return false;
      /*  let alert = Alert.create({
       title: 'No Flights',
       subTitle: 'There is no flight assigned for this competition',
       buttons: ['OK']
       });
       this.nav.present(alert);*/
    } else {
      this.gameRound = this.details.gameRounds
        .filter((gr: GameRoundInfo, idx: number) => {
          return gr.roundNo == this.currentRound;
        })
        .pop();
      let navigationExtras: NavigationExtras = {
        state: {
          competitionId: this.compId,
          competition: this.competition,
          compId: this.compId,
          roundNo: this.gameRound.roundNo,
          gameRound: this.gameRound,
          flights: this.flights,
        },
      };
      this.router.navigate(['tabs/competition-flights'], navigationExtras);
    }
  }

  goTeams() {
    if (this.compTeams.totalItems == 0) {
      let subTitle = 'No teams have been assigned to this competition'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Teams', subTitle);
      return false;
    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          flights: this.flights,
          gameRound: this.gameRound,
          compTeams: this.compTeams,
        },
      };
      // alert('Navigation Left to set');
      this.router.navigate(['tabs/competition-teams'], navigationExtras);
    }
  }
  goHome() {
    console.debug('redirect to home');
    this.router.navigate(['tabs/player-home']);
  }

  onBackpage() {
    this.location.back();
    // this.router.navigate(['tabs/competition-list'], { replaceUrl: true });
  }
  private async onClubRegisterClick(clubId: number) {
    let alert2 = await this.alertCtl.create({
      //title: 'Confirm register',
      header: 'Registration',
      message:
        'This competition is only for <b>' +
        this.competition?.club?.name +
        '</b>. Are you a member of the club?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            alert2.dismiss();
          },
        },
        {
          text: 'Yes',
          handler: () => {
            alert2.dismiss().then(() => {
              this.openMembershipOptions(clubId);
            });
          },
        },
      ],
    });
    alert2.present();
  }

  // private _addMembershipAndRegister(){
  //
  // }
  async openMembershipOptions(clubId: number, membership?: string) {
    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message:
        'Enter your Membership Number for <b>' +
        this.competition?.club?.name +
        '</b> and click Save',
      inputs: [
        {
          name: 'title',
          placeholder: 'Membership Number',
          value: membership,
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Save',
          handler: data => {
            if (data && data.title)
              prompt.dismiss().then(() => {
                this._addMembership(clubId, data.title);
              });
            else {
              // MessageDisplayUtil.showErrorToast(
              //   'You have not entered membership number',
              //   this.platform,
              //   this.toastCtl,
              //   5000,
              //   'bottom'
              // );
              this.onErrorMessage('Register', 'You have not entered membership number');
            }

            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  private _addMembership(clubId: number, membership: string) {
    this.playerService.updateClubMembership(clubId, membership).subscribe(
      () => {
        // this._refreshMemberships();
      },
      error => {},
      () => {
        this.register();
      }
    );
  }

  public async onRegisterClick() {
    if (this.compData.paymentMandatory) {
      this.goPaymentInfo();
      return;
    }
    if (this._checkCompetitionSessions()) {
      this.flightService.getCompetitionDetails(this.compData.id).subscribe(
        compData => {
          if (compData) {
            this.compData = compData;
            this.compService.setCompData(compData);
          }
          console.debug('get comp data', compData, this.compData);
          this._checkCompetitionSessions();
        },
        error => {},
        () => {
          this.goRegisterJoinSession();
        }
      );
      return;
    }
    // let canRegister: boolean = false;
    if (this.competition.type == 'Members') {
      this.getPlayerMembership(this.competition?.club?.name);
      return false;
    } else {
      let _header = 'Registration';
      let _msg = 'Are you sure you want to register?';
      let _subMsg = '';
      if (this.compData?.waitListSize > 0) {
        if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
          if (this.getTotalWaitList() < this.compData.waitListSize) {
            _header = 'Join Wait List';
            _msg = 'Are you sure you want to Join Wait List?';
          }
        }
      }
      let modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'notification',
          header: _header,
          msg: _msg,
          subMsg: _subMsg,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(data => {
        if (data) {
          if (data?.data === 'confirm') {
            this.register();
            // itemSliding?itemSliding.close():null;
            // this.reloadScorecard(false, false);
          }
        }
      });
    }
  }

  private async register(ignoreOverlap: boolean = false, sessionId?: number) {
    let _message = 'Registering...';
    if (this.compData?.waitListSize > 0) {
      if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
        if (this.getTotalWaitList() < this.compData.waitListSize) _message = 'Joining...';
      }
    }
    let register = await this.loadingCtl.create({
      showBackdrop: false,
      message: _message,
    });

    register.present().then(() => {
      // this.compService
      // .register(
      this.flightService
        .compRegisterPlayer(this.compId, this.session.playerId, ignoreOverlap, sessionId)
        .subscribe(
          (result: ServerResult) => {
            console.debug('registering to  : ', register);
            register.dismiss().then(() => {
              if (result.success || result) {
                // this.competition.registered = true;
                // MessageDisplayUtil.showMessageToast(
                //   result.message,
                //   this.platform,
                //   this.toastCtl,
                //   3000,
                //   'bottom'
                // );
                let _msg = 'You are successfully registered to participate in the competition.';
                let _title = 'Registration';
                if (this.compData?.waitListSize > 0) {
                  if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
                    if (this.getTotalWaitList() < this.compData.waitListSize)
                      _title = 'Join Wait List';
                    _msg = 'You have succesfully joined Wait List in the competition.';
                  }
                }
                if (result?.message) _msg = result.message;

                this.onShowMessage(_title, _msg);
                this.refreshPlayers();
                this.refreshCompData();
              } else {
                this._conditionalRegister(result.message);
              }
              this.getPlayerApplicableFee().then(() => {});
            });
          },
          error => {
            register.dismiss().then(() => {
              console.debug('registering to club member only : ', error);
              let _error = error.error;
              let _modifiedMsg: string;
              let msg = MessageDisplayUtil.getErrorMessage(
                _error,
                'Error occured while registering for this comptetition. Try again later.'
              );
              if (
                _error?.errorMessage?.length > 0 &&
                _error?.errorMessage?.toLowerCase().includes('already registered')
              ) {
                _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(
                  _error?.errorMessage,
                  'competition',
                  'b'
                );
              } else _modifiedMsg = _error?.errorMessage;

              if (_error?.errorCode === 'Competition.OverlapRegistration') {
                this.onOverlapRegister(_modifiedMsg);
                return;
              }
              // MessageDisplayUtil.showErrorToast(
              //   msg,
              //   this.platform,
              //   this.toastCtl,
              //   5000,
              //   'bottom'
              // );
              // 'Error occured while registering for this comptetition. Try again later.'
              this.onErrorMessage('Register', _modifiedMsg);
            });
          }
        );
    });
  }

  async onOverlapRegister(message?: string) {
    let _header = 'Overlapped Registration';
    let _msg = 'Do you still want to Register this competition?';
    if (message) _msg = message + '<br>' + _msg;
    let _subMsg = '';
    let modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
      // showBackdrop:true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'negative-confirmation',
        headerTitle: _header,
        confirmMessage: _msg,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data) {
          this.register(true);
        }
      }
    });
  }

  private async _newRegister(
    ignoreOverlap: boolean = false,
    sessionId?: number,
    suppressMessage: boolean = false,
    feeTypeSelected?: string,
    membershipNo?: string
  ) {
    return new Promise(async (resolve, reject) => {
      let _message = 'Registering...';
      if (suppressMessage) _message = '';
      if (this.compData?.waitListSize > 0) {
        if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
          if (this.getTotalWaitList() < this.compData.waitListSize) _message = 'Joining...';
        }
      }
      let register = await this.loadingCtl.create({
        showBackdrop: false,
        message: _message,
      });

      register.present().then(() => {
        // this.compService
        // .register(
        this.flightService
          .compRegisterPlayer(
            this.compId,
            this.session.playerId,
            ignoreOverlap,
            sessionId,
            feeTypeSelected,
            membershipNo
          )
          .subscribe(
            (result: ServerResult) => {
              console.debug('registering to  : ', result);
              register.dismiss().then(() => {
                if (result.success || result) {
                  // this.competition.registered = true;
                  // MessageDisplayUtil.showMessageToast(
                  //   result.message,
                  //   this.platform,
                  //   this.toastCtl,
                  //   3000,
                  //   'bottom'
                  // );
                  let _msg = 'You are successfully registered to participate in the competition.';
                  let _title = 'Registration';
                  if (this.compData?.waitListSize > 0) {
                    if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
                      if (this.getTotalWaitList() < this.compData.waitListSize)
                        _title = 'Join Wait List';
                      _msg = 'You have succesfully joined Wait List in the competition.';
                    }
                  }
                  if (result?.message) _msg = result.message;

                  if (!suppressMessage) this.onShowMessage(_title, _msg);
                  this.refreshPlayers();
                  this.refreshCompData();
                } else {
                  this._conditionalRegister(result.message);
                }
                this.getPlayerApplicableFee()
                  .then((result2: any) => {
                    if (result2) resolve(result);
                  })
                  .catch(error => {
                    resolve(result);
                  });
              });
            },
            error => {
              register.dismiss().then(() => {
                console.debug('registering to club member only : ', error);
                let _modifiedMsg: string;
                let msg = MessageDisplayUtil.getErrorMessage(
                  error,
                  'Error occured while registering for this comptetition. Try again later.'
                );
                if (error?.length > 0 && error?.toLowerCase().includes('already registered')) {
                  _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(error, 'competition', 'b');
                } else _modifiedMsg = error;
                // MessageDisplayUtil.showErrorToast(
                //   msg,
                //   this.platform,
                //   this.toastCtl,
                //   5000,
                //   'bottom'
                // );
                // 'Error occured while registering for this comptetition. Try again later.'
                this.onErrorMessage('Register', _modifiedMsg);
                this.goingToPay = false;
                reject(error);
              });
            }
          );
      });
    });
  }

  private async _conditionalRegister(msg: string) {
    let confirmOverlap = await this.alertCtl.create({
      header: 'Competition Registration',
      message: msg + '. Do you want to still register for this competition ?',
      buttons: [
        {
          text: 'No',
          role: 'Cancel',
          handler: () => {
            confirmOverlap.dismiss();
            return false;
          },
        },
        {
          text: 'Register',
          handler: () => {
            confirmOverlap.dismiss(true);
            return false;
          },
        },
      ],
    });
    confirmOverlap.onDidDismiss().then(data => {
      if (data) {
        this.register(true);
      }
    });
    confirmOverlap.present();
  }

  async onDeregisterClick() {
    if (0) {
      //old design
      let alert = await this.alertCtl.create({
        //title: 'Confirm de-register',
        header: 'De-Register', // 'Confirm to de-register from this competition?',
        message: 'Are you sure you want to de-register from this competition?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              alert.dismiss();
              return false;
            },
          },
          {
            text: 'Yes',
            handler: () => {
              alert.dismiss().then(() => {
                this.deregister();
              });
              return false;
            },
          },
        ],
      });
      alert.present();
    } else {
      let _header = 'De-Register';
      let _msg = 'Are you sure you want to de-register from this competition?';
      let _subMsg = '';
      if (this.isWaitListed()) {
        _header = 'Remove from Wait List';
        _msg = 'Are you sure you want to be de-listed from Wait List?';
      }
      let modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'notification',
          header: _header,
          msg: _msg,
          subMsg: _subMsg,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(data => {
        if (data) {
          if (data?.data === 'confirm') {
            if (this.isWaitListed()) this.removeFromWaitList();
            else this.deregister();
            // itemSliding?itemSliding.close():null;
            // this.reloadScorecard(false, false);
          }
        }
      });
    }
  }

  async deregister() {
    let busy = await this.loadingCtl.create({
      message: 'Deregistering...',
    });
    busy.present().then(() => {
      this.compService.deregister(this.compId, this.session.playerId).subscribe(
        (result: ServerResult) => {
          busy.dismiss().then(() => {
            // this.competition.registered = false;
            // MessageDisplayUtil.showMessageToast(
            //   result.message,
            //   this.platform,
            //   this.toastCtl,
            //   3000,
            //   'bottom'
            // );
            this.goingToPay = false;
            this.onShowMessage('De-register', result.message);
            this.refreshPlayers();
            this.refreshCompData();
            this.getPlayerApplicableFee().then(() => {});
          });
        },
        error => {
          console.debug('error deregistering : ', error);
          let msg = MessageDisplayUtil.getErrorMessage(
            error,
            'Error de-registering from competition. Try again later.'
          );
          msg = 'Error de-registering from competition. Try again later.';
          if (error?.length) {
            msg = error;
            if (msg?.toLowerCase().includes('already done the payment'))
              msg = 'You cannot deregister once payment has been made.';
          }
          if (busy) busy.dismiss();
          // MessageDisplayUtil.showErrorToast(
          //   msg,
          //   this.platform,
          //   this.toastCtl,
          //   5000,
          //   'bottom'
          // );
          this.getPlayerApplicableFee().then(() => {});
          this.onErrorMessage('De-register', msg);
        }
      );
    });
  }

  /**
   * Refresh the competition details from the server
   * @param refresher
   */

  selectGameRound(roundNo) {
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => {
        return gr.roundNo == roundNo;
      })
      .pop();
    return this.gameRound;
  }

  checkRoundInProgress() {
    if (this.competition.status == 'In Progress') {
      if (this.gameRound.roundNo == this.currentRound) {
        if (this.gameRound.status == 'Pending' || this.gameRound.status == 'InProgress')
          return true;
        else return false;
      }
    } else return false;
  }

  checkRoundCompleted() {
    //let gameRound = this.selectGameRound(this.currentRound)

    if (this.competition.status == 'Completed') {
      return true;
    } else if (this.competition.status == 'In Progress') {
      if (this.gameRound && this.gameRound.status == 'Completed') return true;
    }
  }

  async onDescriptionClick() {
    const modal = await this.modalCtl.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        descriptionMenuActive: 'description',
        competition: this.competition,
        details: this.details,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onRulesClick() {
    let modal = await this.modalcontroler.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        competition: this.competition,
        compId: this.compId,
        descriptionMenuActive: 'rules',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onCourseClick() {
    let modal = await this.modalcontroler.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        competition: this.competition,
        compId: this.compId,
        descriptionMenuActive: 'courses',
        details: this.details.gameRounds,
        roundCourseRatings: this.compRoundCourseRatings,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  private async getPlayerMembership(clubName: string) {
    let selectedClubName: string = '';
    let loader = await this.loadingCtl.create({
      showBackdrop: false,
    });
    loader.onDidDismiss().then((data: any) => {
      //

      if (data) {
        this.clubName = data.data
          .map((membership: ClubMembership, idx: number) => {
            //return membership.homeClub
            return (membership.club.clubName = clubName);
          })
          .pop();

        selectedClubName = this.clubName;
        //
        //
        //
        if (this.clubName == clubName) this.register();
        else this.onClubRegisterClick(this.competition?.club?.id);
      } else return false;
    });
    loader.present();
    this.playerService.getPlayerMemberships().subscribe(
      (memberships: Array<ClubMembership>) => {
        this.memberships = memberships;

        // this.clubIds = [];
        // memberships.forEach((m: ClubMembership) => {
        //     this.clubIds.push(m.club.clubId);
        // });
      },
      error => {
        let msg = MessageDisplayUtil.getErrorMessage(error);
        MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Membership', msg, 'OK');
        loader.dismiss(null);
      },
      () => {
        loader.dismiss(this.memberships);
      }
    );
  }

  prizeCount(): number {
    let prizeTotal = 0;

    if (this.details.prizes.length && this.details.teamPrizes.length)
      prizeTotal = this.details.teamPrizes.length + this.details.prizes.length;
    else if (this.details.teamPrizes.length) prizeTotal = this.details.teamPrizes.length;
    else if (this.details.prizes.length) prizeTotal = prizeTotal = this.details.prizes.length;

    return prizeTotal;
  }

  selectedRound(roundNo: number, fab: any) {
    this.currentRound = roundNo;
    //  this.roundInfo = this.getSelectedRoundInfo();
    //this.doRefresh(null);
    //+ this.roundInfo.id
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo) => {
        return gr.roundNo == this.currentRound;
      })
      .pop();
    this.freshCompInfo = false;
    this._refreshCompetitionInfo(null);
    this.getCompMatches();
  }

  goPayment() {
    let playerInfo: PlayerInfo;
    let _compPlayer = this.details?.players?.filter(cp => {
      return cp?.playerId === this.session?.playerId;
    })[0];

    this.playerService
      .getPlayerInfo(this.session.playerId)
      .subscribe(async (player: PlayerInfo) => {
        let modal = await this.modalCtl.create({
          component: CompetitionPaymentConfirm,
          componentProps: {
            details: this.details,
            competition: this.competition,
            compId: this.compId,
            player: player,
            compData: this.compData,
            compPlayerId: _compPlayer?.id,
          },
        });

        modal.onDidDismiss().then((data: any) => {
          if (data) {
            if (data.paid.toLowerCase() === 'paid' && data.success) {
              this.register();
            }
          }
        });
        modal.present();
      });

    // modal.onDidDismiss((data: any) => {

    //     if (data) {

    //         if(data.type === 'testCall') {
    //             // this.testCall();
    //         } else if(data.type === 'getRemoteCollections') {
    //             this.getRemoteCollections(data.collectionId);
    //         }else if(data.type === 'getLocalCollections') {
    //             this.getLocalCollections(data.collectionId);
    //         } else if(data.type === 'getBill') {
    //             this.getBill(data.billId);
    //         } else if(data.type === 'createBill') {
    //             this.createBill(data.collectionId);
    //         } else if(data.type === 'createRemoteBill') {
    //             this.createRemoteBill(data.collectionId);
    //         }
    //         // this.scorecard = data.scorecard
    //         // this._onCurrentHoleChange();
    //     }
    // });
  }

  async openPaymentSelection() {
    if (this.getPaymentStatus() === 'Full' || this.getPaymentStatus() === 'Nothing') return;
    let _compPlayer = this.compData?.players?.filter(cp => {
      return cp?.player?.id === this.session?.playerId;
    })[0];
    const _playerInfo$ = this.player$.pipe(take(1)).toPromise();
    console.debug('opening payment selection ', _compPlayer, this.compData?.players, _playerInfo$);
    const modal = await this.modalCtl.create({
      component: CompetitionPaymentSelectionPage,
      cssClass: 'full-screen-modal',
      componentProps: {
        competitionDetails: this.details,
        compData: this.compData,
        competitionFeeApplicable: this.currentFeeApplicable,
        compPlayerId: _compPlayer?.id,
        playerId: this.session?.playerId,
        playerInfo: _playerInfo$,
      },
      mode: 'ios',
    });

    modal.onDidDismiss().then(async data => {
      this.onRefreshClick(null);
    });
    await modal.present().then();
  }

  getTestCallAPI() {
    this.compService.testAPIcall().subscribe(data => {});
  }
  getPlayerStatus() {
    if (!this.flights) return false;
    if (!this.player$) return false;
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight: FlightMoreData; //Array<FlightInfo>;
    let _playerStatus: any; //Array<FlightMember>;

    this.flights
      .filter((flight: FlightMoreData) => {
        return flight.playerFlight;
        // _playerInFlight = flight.flightMembers.filter((flightMember)=>{
        //   return flightMember.playerId === _player.playerId
        // })
      })
      .map((flight: FlightMoreData) => {
        _playerInFlight = flight;
      });
    if (_playerInFlight && _playerInFlight.flightMembers.length > 0) {
      _playerInFlight.flightMembers
        .filter((member: any) => {
          return member.playerId === _player.playerId;
        })
        .map((member: any) => {
          _playerStatus = member;
        });

      if (_playerStatus) {
        return _playerStatus.status;
      } else return false;
    } else return false;
  }

  goLeagueScorecardOld() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        leaderboards: this.leaderBoard,
        leaderboardPlayers: this.leaderBoard.players,
        roundNo: this.currentRound,
        categories: this.details.categories,
        teams: this.competition.teamEvent ? null : null,
        showTeam: this.showTeam,
      },
    };
    // this.router.navigate(['competition-players'], navigationExtras);
    // this.nav.push(LeagueLeaderboardPage)
  }

  goLeagueLeaderboardOld() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        leaderboards: this.leaderBoard,
        leaderboardPlayers: this.leaderBoard.players,
        roundNo: this.currentRound,
        categories: this.details.categories,
        teams: this.competition.teamEvent ? null : null,
        showTeam: this.showTeam,
      },
    };
    // this.router.navigate(['competition-players'], navigationExtras);
    // this.nav.push(LeagueLeaderboardPage)
  }

  async isCompetitionEclectic() {
    console.debug('is competition eclectic', this.compData);
    if (!this.compData) return;
    this.isEclectic = this.compData?.leagueSeasons?.some((ls: LeagueSeason) => {
      if (ls?.leagueType === 'Eclectic') {
        this.compSeasonId = ls?.id;
        return true;
      }
    });
    return this.isEclectic;
  }

  goLeagueMenuOld() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
      },
    };
    this.router.navigate(['tabs/competition-league-menu'], navigationExtras);
  }

  async goLeagueMenu() {
    if (1) {
      // if(this.compData?.leagueSeasons?.length > 1) {

      let navigationExtras: NavigationExtras = {
        state: {
          leagueSeasons: this.compData.leagueSeasons,
          competition: this.competition,
          compSeasonId: this.compSeasonId,
        },
      };
      this.router.navigate(['tabs/competition-league-menu'], navigationExtras);

      // const modal = await this.modalCtl.create({
      //   mode: 'ios',
      //   component: CompetitionLeagueMenuPage,
      //   cssClass: 'full-screen-modal', // 'self-adjustable-modal',
      //   componentProps: {
      //       app: null,
      //       mode: 'common',
      //       headerTitle: 'Competition League',
      //       leagueSeasons: this.compData.leagueSeasons,
      //       competition: this.competition,
      //       compSeasonId: this.compSeasonId,
      //   }
      // })
      // await modal.present().then(() => {
      //     const height = this.platform.height() - 250;
      //     if(document.getElementsByClassName('inner-content')[0])
      //     document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      // });
      // modal.onDidDismiss().then((data: any) => {
      //   console.debug("pullup dismiss", data)
      //   if(data) {
      //     if(data?.data?.id === 'leaderboard') {
      //       this.goLeagueLeaderboard();
      //     } else if(data?.data?.id === 'scorecards') {
      //       this.goLeagueScorecard();
      //     } else if(data?.data?.id === 'lowestAverage') {
      //       this.goLeagueLowestLeaderboard();
      //     }
      //   }
      //   // if(data)

      // })
      return;
    }
    let _dataList = [
      {
        id: 'leaderboard',
        name: 'Leaderboard',
        iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'scorecards',
        name: 'Scorecards',
        iconUrl: 'assets/icons/book.png',
      },
      {
        id: 'lowestAverage',
        name: 'Lowest Average',
        iconUrl: 'assets/icons/golf-field.png',
      },
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Competition League',
        subTitle: this.leagueRounds ? this.leagueRounds[0].seasonName : '',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'leaderboard') {
          this.goLeagueLeaderboard();
          // this.goEclecticLeaderboard();
        } else if (data?.data?.id === 'scorecards') {
          this.goLeagueScorecard();
        } else if (data?.data?.id === 'lowestAverage') {
          this.goLeagueLowestLeaderboard();
        }
      }
      // if(data)
    });
  }

  goLeagueScorecard() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-scorecard'], navigationExtras);
  }
  goLeagueLeaderboard() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
        leagueType: 'Eclectic',
      },
    };
    this.router.navigate(['tabs/competition-league-leaderboard'], navigationExtras);
  }

  goLeagueLowestLeaderboard() {
    let navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-lowest'], navigationExtras);
  }

  compSeasonId: number;
  leagueRounds: Array<LeagueRound>;
  getLeagueSeason() {
    this.flightService.getLeagueSeason(this.compId).subscribe(data => {
      this.compSeasonId = data;
      this.getLeagueRounds(data);
      // this.refreshLeagueScorecards(this.compId);
    });
  }

  getLeagueRounds(seasonId: number) {
    this.flightService.getLeagueRounds(seasonId).subscribe(data => {
      if (data) this.leagueRounds = data;
    });
  }

  async moreDetailsTournament() {
    const modal = await this.modalCtl.create({
      component: DescriptionModalPage,
      showBackdrop: true,
      backdropDismiss: true,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps: {
        descriptionMenuActive: 'moreDetails',
        totalRounds: this.competition?.totalRounds,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    await modal.onDidDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'description':
            this.onDescriptionClick();
            break;
          case 'rules':
            this.onRulesClick();
            break;
          case 'courses':
            this.onCourseClick();
            break;
          case 'refresh':
            this.onRefreshClick(null);
            break;
          case 'changeRound':
            this.onClickRounds();
            break;
        }
      }
    });
  }

  async onClickRounds() {
    let _dataList = [];

    if (this.details?.gameRounds?.length > 0)
      this.details.gameRounds.forEach(round => {
        _dataList.push({
          id: round.roundNo,
          name: 'Round ' + round.roundNo,
        });
      });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'View Round',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id) {
          this.selectedRound(data.data.id, null);
        }
      }
      // if(data)
    });
  }

  compRoundCourseRatings: Array<CompetitionRoundCourseRatings> = [];
  getCompRoundCourseRatings() {
    let _compId = this.compId;
    this.flightService
      .getCompetitionCourseSlopeRatings(_compId, false)
      .subscribe((courseRatings: Array<CompetitionRoundCourseRatings>) => {
        this.compRoundCourseRatings = courseRatings;
      });
  }

  async onShowMessage(subtitle: string, body: string) {
    let _message = {
      subtitle: subtitle,
      body: body,
    };
    let modal = await this.modalcontroler.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        message: _message,
        descriptionMenuActive: 'message',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onErrorMessage(subtitle: string, body: string) {
    let _message = {
      subtitle: subtitle,
      body: body,
    };
    let modal = await this.modalcontroler.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        message: _message,
        descriptionMenuActive: 'message',
        isError: true,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  private _checkCompetitionSessions() {
    if (!this.compData) return false;
    let _hasSessions = this.compData.gameRounds.find((round: GameRoundData) => {
      return round.roundNo === 1 && round.sessions?.length > 0;
    });
    console.debug('comp session ', _hasSessions, this.compData);
    if (_hasSessions) {
      this.compSessions = _hasSessions.sessions;
      return true;
    } else return false;
  }

  async goRegisterJoinSession() {
    if (!this.compSessions) return;
    let _dataList = [];
    if (this.compSessions?.length > 0) {
      this.compSessions.forEach(session => {
        let _slotsLeft = 0;
        let _slotsTaken = 0;
        if (session.sessionPlayers?.length > 0) _slotsTaken = session.sessionPlayers.length;
        _slotsLeft = session.maxSlots - _slotsTaken;
        if (session.allowJoinSession)
          _dataList.push({
            id: session.sessionId,
            name:
              moment(session.startTime, 'HH:mm:ss').format('hh:mm A') +
              ' ( ' +
              (_slotsLeft + ' / ' + session.maxSlots) +
              ' slots )',
            disabled: _slotsLeft > 0 ? false : true,
          });
      });
    }
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'singleSelection', //'common',
        headerTitle: 'Multi-Sessions Competition',
        subTitle: 'Choose available session to join',
        firstBtnTxt: 'Join',
        secondBtnTxt: 'Cancel',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        this.register(false, data.data.id);
      }
      // if(data)
    });
  }

  refreshCompData() {
    let _compId = this.compId || this.compData?.id;
    this.flightService.getCompetitionDetails(_compId).subscribe((compData: CompetitionData) => {
      if (compData) {
        this.compData = compData;
        this.compId = this.compData?.id;
        if (this.isCompetitionEclectic()) {
          // this.getLeagueSeason();
          this.getLeagueRounds(this.compSeasonId);
        }
        if (compData?.matchPlay) {
          this.getCompMatches();
          this.getCompTeamPlayers();
        }
        this._checkCompetitionSessions();
        this.compService.setCompData(compData);
        // this.goingToPay = false;
        this.getPlayerApplicableFee().then(() => {});
      }
      console.debug('get comp data', compData, this.compData);
    });
  }

  getRoundStatus() {
    // if(!this.compData) return '';
    if (!this.currentRound) return '';
    // console.debug(" get round status : ", this.compData?.status, this.currentRound)
    if (
      this.compData &&
      (this.compData?.status === 'Completed' ||
        this.compData?.status === 'Cancelled' ||
        this.compData?.status === 'Upcoming')
    )
      return this.compData.status;
    else if (!this.compData && this.competition?.status) return this.competition.status;
    else {
      if (this.compData?.gameRounds?.length === 1) return this.compData.status;
      else {
        let _roundStatus = this.compData?.gameRounds.find(round => {
          // console.debug(" get round status : ", round)
          return round.roundNo === this.currentRound;
        });
        return this.mg2uUtils.separateWords(_roundStatus.status);
      }
    }
  }

  getClassStatus() {
    if (this.getRoundStatus().toLowerCase().includes('in progress')) return 'inProgress';
    else if (this.getRoundStatus().toLowerCase().includes('completed')) return 'completed';
    else if (this.getRoundStatus().toLowerCase().includes('elapsed')) return 'upComing';
    else if (this.getRoundStatus().toLowerCase().includes('upcoming')) return 'upComing';
    else if (this.getRoundStatus().toLowerCase().includes('pending')) return 'upComing';
    else if (this.getRoundStatus().toLowerCase().includes('cancelled')) return 'cancelled';
    // {'inProgress' : getRoundStatus().toLowerCase().includes('in progress') ,
    //                             'completed': getRoundStatus().toLowerCase().includes('completed')  ,
    //                             'upComing': getRoundStatus().toLowerCase().includes('elapsed') ,
    //                             'upComing': getRoundStatus().toLowerCase().includes('upcoming'),
    //                             'upComing': getRoundStatus().toLowerCase().includes('pending'),
    //                             'cancelled': getRoundStatus().toLowerCase().includes('cancelled')}
  }

  getRegisterText() {
    let _text = 'Register Now';
    if (this.isWaitListed()) {
      _text = 'Already Wait Listed';
      return _text;
    }
    if (this.compData?.waitListSize > 0) {
      if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
        if (this.getTotalWaitList() < this.compData.waitListSize) _text = 'Join Waitlist';
      }
    }
    return _text;
  }

  getDeregisterText() {
    let _text = 'Deregister';
    if (this.isWaitListed()) {
      _text = 'Remove from wait list';
    }
    return _text;
  }

  isRegistered() {
    if (!this.compData) return;
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
      // console.debug("current player ", player)
    });
    let _isRegistered: boolean = false;
    if (this.compData?.players?.length > 0) {
      if (
        this.compData.players.find((cp: CompetitionPlayerData) => {
          return (
            (cp?.player?.id === _player?.playerId || cp?.player?.id === _player?.id) &&
            cp?.status === 'Registered'
          );
        })
      )
        _isRegistered = true;
    }

    return _isRegistered;
  }

  isWaitListed() {
    if (!this.compData) return;
    if (this.compData?.waitListSize === 0) return false;
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
      console.debug('current player ', player);
    });
    let _isWaitListed: boolean = false;
    if (this.compData?.waitLists?.length > 0)
      if (
        this.compData.waitLists.find((wl: CompetitionWaitList) => {
          return (
            (wl?.player?.id === _player?.playerId || wl?.player?.id === _player?.id) &&
            wl?.status === 'WaitListed'
          );
        })
      )
        _isWaitListed = true;
    return _isWaitListed;
  }

  getTotalWaitList(status?: string) {
    if (!this.compData) return;
    let _totalWaitListed = 0;
    if (this.compData?.waitLists?.length > 0) {
      _totalWaitListed = this.compData.waitLists.filter((wl: CompetitionWaitList) => {
        if (status?.length > 0) return wl.status === status;
        else return wl.status === 'WaitListed';
      })?.length;
    }
    return _totalWaitListed;
  }

  getTotalRegistered() {
    if (!this.compData) return;
    let _totalRegistered = 0;
    if (this.compData?.players?.length > 0) {
      _totalRegistered = this.compData.players.filter((cp: CompetitionPlayerData) => {
        return cp?.status === 'Registered';
      })?.length;
    }
    return _totalRegistered;
  }

  async removeFromWaitList() {
    let register = await this.loadingCtl.create({
      showBackdrop: false,
      message: 'Removing...',
    });

    register.present().then(() => {
      this.flightService.compCancelWaitlist(this.compId, this.session.playerId).subscribe(
        (result: ServerResult) => {
          console.debug('registering to  : ', register);
          register.dismiss().then(() => {
            if (result.success || result) {
              // this.competition.registered = true;
              // MessageDisplayUtil.showMessageToast(
              //   result.message,
              //   this.platform,
              //   this.toastCtl,
              //   3000,
              //   'bottom'
              // );
              let _msg = 'You are successfully de-listed from Wait List.';
              if (result?.message) _msg = result.message;

              this.onShowMessage('De-listed', _msg);
              this.refreshPlayers();
              this.refreshCompData();
            } else {
              this._conditionalRegister(result.message);
            }
          });
        },
        error => {
          register.dismiss().then(() => {
            let _modifiedMsg: string;
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error occured while de-listing from Wait List. Try again later.'
            );
            if (error?.length > 0 && error?.toLowerCase().includes('already registered')) {
              _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(error, 'competition', 'b');
            } else _modifiedMsg = error;
            // MessageDisplayUtil.showErrorToast(
            //   msg,
            //   this.platform,
            //   this.toastCtl,
            //   5000,
            //   'bottom'
            // );
            // 'Error occured while registering for this comptetition. Try again later.'
            this.onErrorMessage('Register', _modifiedMsg);
          });
        }
      );
    });
  }

  isClosedForRegistration() {
    let _currDate = moment();
    let _closeDate = moment(
      this.compData?.closeDate + ' ' + this.compData?.registrationCloseTime,
      'YYYY-MM-DD HH:mm:ss'
    );
    // console.debug("closed for registration", _currDate.isAfter(_closeDate, 'minute'))
    return _currDate.isAfter(_closeDate, 'minute');
  }

  getCompImage() {
    // console.debug("get club image [0] : ", this.clubMembership)
    if (!this.compData) return 'assets/image/default/default_competition.jpg';
    let _compImage = '';
    if (this.compData.image) _compImage = this.compData?.image;
    else if (this.compData?.thumbnail) _compImage = this.compData?.thumbnail;
    else return 'assets/image/default/default_competition.jpg';

    // console.debug("get club image [1] : ", _clubImage)
    if (_compImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase())) return _compImage;
    else return global.MygolfServer + '/' + _compImage;
  }

  parseTime(time: string, format?: string) {
    if (!!format) return moment(time, 'HH:mm:ss').format(format);
    else return moment(time, 'HH:mm:ss').format('hh:mm A');
  }

  getCompFee() {
    if (!this.compData) return;
    // if(!this.currentFeeApplicable) return;

    let _compPlayer = this.compData?.players?.filter(cp => {
      return cp?.player?.id === this.session?.playerId;
    })[0];

    let _amounTtxt = '';
    let _currency = this.compData?.currency?.symbol || this.currentFeeApplicable?.currencySymbol;
    if (_compPlayer?.feePayable) _amounTtxt = _currency + ' ' + _compPlayer?.feePayable;
    else if (this.currentFeeApplicable)
      _amounTtxt = _currency + ' ' + this.currentFeeApplicable?.applicableFee;
    else _amounTtxt = _currency + ' ' + this.compData?.tournamentFee;
    // let _balance = this.currentFeeApplicable?.applicableFee;
    // if(this.currentFeeApplicable?.paymentAmount) _balance = this.currentFeeApplicable?.applicableFee - this.currentFeeApplicable?.paymentAmount;
    return _amounTtxt;
  }

  needPayment() {
    if (!this.compData) return;
    return this.compData?.paymentMandatory;
  }

  classPaymentColor() {
    if (!this.currentFeeApplicable) return '';
    switch (this.getPaymentStatus() || this.currentFeeApplicable?.paymentStatus) {
      case 'Unpaid':
        return 'unpaid';
      case 'Partial':
        return 'partially-paid';
      case 'Full':
        return 'fully-paid';
      case 'Nothing':
        return 'fully-paid';
      default:
        return 'unpaid';
    }
  }

  getPaymentStatus() {
    if (!this.currentFeeApplicable) return;
    if (
      this.currentFeeApplicable?.paymentStatus !== 'Full' &&
      this.currentFeeApplicable?.applicableFee === 0
    )
      return 'Nothing';
    if (
      this.currentFeeApplicable?.paymentStatus === 'Full' &&
      this.currentFeeApplicable?.applicableFee === 0
    )
      return 'Nothing';
    let _paymentStatus = this.compData?.players?.filter(cp => {
      return cp?.player?.id === this.session?.playerId;
    })[0]?.paymentStatus;
    return _paymentStatus || this.currentFeeApplicable?.paymentStatus;
  }

  getDerivedPaymentStatus(paymentStatus: string) {
    let _paymentStatus = paymentStatus?.toLowerCase();
    switch (_paymentStatus) {
      case 'full':
        return 'Fully Paid';
      case 'unpaid':
        return 'Pending Payment';
      case 'partial':
        return 'Partially Paid';
      case 'nothing':
        return 'Nothing to Pay';
    }
  }

  goingToPay: boolean = false;
  currentFeeApplicable: CompetitionFeeApplicable;
  getPlayerApplicableFee() {
    return new Promise((resolve, reject) => {
      if (!this.compData) return;
      let _playerIds = [];
      if (this.session?.playerId) _playerIds.push(this.session?.playerId);

      // this.player$.pipe(take(1)).subscribe((player) => {
      //   _playerIds.push(player?.playerId | player?.id)
      // });
      console.debug('get player applicable fee', _playerIds, this.player$);
      if (this.goingToPay || this.isRegistered()) {
        this.flightService
          .getCompApplicableFee(this.compData?.id, _playerIds, this.goingToPay)
          .subscribe(
            (data: Array<CompetitionFeeApplicable>) => {
              if (data) {
                this.currentFeeApplicable = data?.filter((cfa: CompetitionFeeApplicable) => {
                  return cfa?.player?.playerId === _playerIds[0];
                })[0];
                console.debug('get player applicable fee', this.currentFeeApplicable, data);
                resolve(data);
              }
            },
            error => {
              reject(error);
            },
            () => {
              // resolve(true)
            }
          );
      } else {
        this.flightService.getCompEstimatedFee(this.compData?.id, _playerIds[0]).subscribe(
          (data: CompetitionFeeApplicable) => {
            if (data) {
              this.currentFeeApplicable = data;
              console.debug('get player estimated fee', this.currentFeeApplicable, data);
              resolve(data);
            }
          },
          error => {
            reject(error);
          },
          () => {
            // resolve(true)
          }
        );
      }
    });
  }

  paymentClicked: boolean = false;
  goPaymentInfo() {
    if (this.paymentClicked) return;
    this.paymentClicked = true;
    if (this.isClosedForRegistration() && this.compData?.paymentMandatory) {
      this.paymentClicked = false;
      MessageDisplayUtil.showErrorToast(
        'Registration has been closed',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    this.getPlayerApplicableFee()
      .then((result: any) => {
        if (result) {
          if (!this.compData?.paymentMandatory) this.openPaymentInfo();
          else if (this.getPaymentStatus() === 'Full' || this.getPaymentStatus() === 'Nothing')
            this.openPaymentInfo();
          else this.openPaymentInfo();
        }
      })
      .catch(error => {
        MessageDisplayUtil.showErrorToast(error, this.platform, this.toastCtl, 5000, 'bottom');
      });
  }

  async openPaymentInfo(onlyPaymentInfo?: boolean) {
    this.paymentClicked = false;

    let _mode = 'compRegister';
    let _title = 'Register & Pay';
    let _firstBtnTxt = 'Register & Pay';
    let _secondBtnTxt = 'Register';
    let _paymentStatus = '';
    let _showSecondBtn = true;
    let _balance =
      this.currentFeeApplicable?.applicableFee - this.currentFeeApplicable?.paymentAmount;
    let _feeApplicable = '';
    let _extraCheckboxOption;
    let _currency = this.compData?.currency?.symbol || this.currentFeeApplicable?.currency;

    if (this.currentFeeApplicable)
      _feeApplicable = `<br><br>The fee is <b>${this.currentFeeApplicable?.currencySymbol} ${_balance}</b>.`;

    let _compPlayer = this.compData?.players?.filter(cp => {
      return cp?.player?.id === this.session?.playerId;
    })[0];
    let _needPayment =
      this.compData?.paymentMandatory &&
      (this.getPaymentStatus() === 'Unpaid' || this.getPaymentStatus() === 'Partial');

    let _closeDate = moment(
      this.compData?.closeDate + ' ' + this.compData?.registrationCloseTime,
      'YYYY-MM-DD HH:mm:ss'
    ).format('ddd, DD MMM YYYY hh:mm A');
    let _content = `To secure your registration, <b>Pay Online</b> before <b>${_closeDate}</b>`;
    // <br><br>Tap <b>Register & Pay</b> to proceed with payment via the gateway, or Tap <b>Register</b> to register now and pay later.
    // ${_feeApplicable}

    let _inputRequired: boolean = false;
    if (
      _compPlayer?.feeTypeSelected !== 'ClubMember' &&
      (!_compPlayer?.golfClubMembership || _compPlayer?.golfClubMembership?.length === 0) &&
      this.currentFeeApplicable?.feeType !== 'Club Member'
    ) {
      _extraCheckboxOption = {
        id: 'ClubMember',
        name: `I'm a Club Member`,
        checked: false,
      };
      _inputRequired = true;
    }
    // else if(_compPlayer?.feeTypeSelected !== 'OrganizerMember') {
    //   _extraCheckboxOption = {
    //     id: 'OrganizerMember',
    //     name: `I'm an Organizer Member`,
    //     checked: false,
    //   }
    // }

    let _orgMemberFee = this.compData?.tournamentFeeOrgMember;
    let _clubMemberFee = this.compData?.tournamentFeeClubMember;
    if (1) {
      _content += `<br><br>Non-Member <b>${_currency} ${this.compData?.tournamentFee}</b>`;
      if (_orgMemberFee) _content += `<br>Organizer Member <b>${_currency} ${_orgMemberFee}</b>`;
      if (_clubMemberFee) _content += `<br>Club Member <b>${_currency} ${_clubMemberFee}</b>`;
    }
    if (onlyPaymentInfo) {
      _title = `Registration Fee`;
      _content = `Non-Member ${_currency} ${this.compData?.tournamentFee}`;
      if (_orgMemberFee) _content += `<br>Organizer Member ${_currency} ${_orgMemberFee}`;
      if (_clubMemberFee) _content += `<br>Club Member ${_currency} ${_clubMemberFee}`;
      _content += `<br><br>Online payment is not available`;
      _mode = 'infoDisplay';
      _extraCheckboxOption = null;
    } else {
      if (this.isRegistered() && _needPayment) {
        _firstBtnTxt = 'Pay Now';
        _title = 'Payment Status';
        _showSecondBtn = false;
        _content = `To secure your registration, <b>Pay Online</b> before <b>${_closeDate}</b><br><br>Your payment status is <b>${this.getDerivedPaymentStatus(this.getPaymentStatus())}</b>.<br><br>The fee is <b>${this.currentFeeApplicable?.currencySymbol} ${this.currentFeeApplicable?.applicableFee}</b>.<br><br>Tap <b>Pay Now</b> to make payment.`;

        _extraCheckboxOption = null;
      } else if (!this.compData?.paymentMandatory) {
        _title = `Registration Fee`;
        _content = `Non-Member ${_currency} ${this.compData?.tournamentFee}`;
        if (_orgMemberFee) _content += `<br>Organizer Member ${_currency} ${_orgMemberFee}`;
        if (_clubMemberFee) _content += `<br>Club Member ${_currency} ${_clubMemberFee}`;
        _content += `<br><br>Online payment is not available`;
        _mode = 'infoDisplay';
        _extraCheckboxOption = null;
      } else if (
        this.isRegistered() &&
        (this.getPaymentStatus() === 'Full' || this.getPaymentStatus() === 'Nothing')
      ) {
        _title = `Registration Fee`;
        let _orgMemberFee = this.compData?.tournamentFeeOrgMember;
        let _clubMemberFee = this.compData?.tournamentFeeClubMember;
        _content = `Non-Member ${_currency} ${this.compData?.tournamentFee}`;
        if (_orgMemberFee) _content += `<br>Organizer Member : ${_currency} ${_orgMemberFee}`;
        if (_clubMemberFee) _content += `<br>Club Member : ${_currency} ${_clubMemberFee}`;
        _mode = 'infoDisplay';
        _extraCheckboxOption = null;
      }

      if (this.compData?.waitListSize > 0) {
        if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
          if (this.getTotalWaitList() < this.compData.waitListSize) {
            _content += `<br><br>Are you sure you want to Join Wait List?`;
          }
        }
      }
    }

    if (this.compData?.tournamentFeeClubMember === null) _extraCheckboxOption = null;
    let _message = {
      title: _title,
      content: _content,
    };

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        mode: _mode,
        // headerTitle: 'View Round',
        message: _message,
        firstBtnTxt: _firstBtnTxt,
        secondBtnTxt: _secondBtnTxt,
        showConfirmBtn: _showSecondBtn,
        extraCheckboxOption: _extraCheckboxOption,
        inputRequired: _inputRequired,
        competitionFeeApplicable: this.currentFeeApplicable,
        competitionData: this.compData,
        membershipNo:
          this.currentFeeApplicable?.golfClubMembership || _compPlayer?.golfClubMembership,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(async (data: any) => {
      console.debug('pullup dismiss', data);
      // data?.data?.membershipNo || data?.data?.extraCheckboxOption?.id
      if (data?.data) {
        let _feeTypeSelected = data?.data?.extraCheckboxOption?.checked
          ? data?.data?.extraCheckboxOption?.id
          : null;
        let _membershipNo = data?.data?.membershipNo;
        if (data?.data?.type === 2) {
          console.debug('register first');
          // this.register();

          this._newRegister(null, null, true, _feeTypeSelected, _membershipNo).then(
            (result: any) => {}
          );
        } else if (data?.data?.type === 1) {
          console.debug(
            'register and pay',
            this.isRegistered(),
            _needPayment,
            this.compData?.paymentUrl
          );
          if (this.isRegistered() && _needPayment) {
            this.goingToPay = true;
            this.getPlayerApplicableFee().then((result: any) => {
              if (result) {
                if (this.currentFeeApplicable?.applicableFee === 0) {
                } else this.openPaymentSelection();
              }
            });
          } else {
            this.goingToPay = true;
            this._newRegister(null, null, true, _feeTypeSelected, _membershipNo).then(
              async (registered: any) => {
                let busy = await this.loadingCtl.create({
                  message: 'Redirecting to payment page...',
                  backdropDismiss: false,
                });
                busy.present().then(() => {
                  if (registered) {
                    setTimeout(() => {
                      if (busy) busy.dismiss();
                      this.openPaymentSelection();
                    }, 750);
                    // const refresh$ = of(this.refreshCompData());
                    // const openPaymentSelection$ = of(this.openPaymentSelection());
                    // console.debug("registered ", this.compData)
                    // forkJoin([refresh$, openPaymentSelection$]).pipe((map((values: Array<any>)=>{

                    // })))
                  }
                });
              }
            );
            //   try {
            //     const register$ = from(this._newRegister(null,null, true));
            //     const getPlayerApplicableFee$ = from(this.getPlayerApplicableFee());

            // forkJoin([register$, getPlayerApplicableFee$ ]).pipe(
            //   map((values: Array<any>) => {
            //     console.debug("fork join", values, this.currentFeeApplicable)
            //     return values[0] && values[1]
            //   })).subscribe((result: any)=>{
            //     console.debug("fork join [1]", result, this.currentFeeApplicable)
            //     if(result) {
            //       this.openPaymentSelection();
            //     }
            //   });
            //   } catch {

            //   }
          }
        }
      }
    });
  }

  getApplicableFeeType() {
    let _compPlayer = this.compData?.players?.filter(cp => {
      return cp?.player?.id === this.session?.playerId;
    })[0];

    // if(_compPlayer) {
    //   if(_compPlayer?.feeTypeSelected === 'Auto' && _compPlayer?.golfClubMembership) return 'ClubMember';
    //   else if(_compPlayer?.feeTypeSelected === 'Auto' && (!_compPlayer?.golfClubMembership || _compPlayer?.golfClubMembership?.length === 0)) return 'Standard';
    //   else return _compPlayer?.feeTypeSelected;
    // } else {
    return this.currentFeeApplicable?.feeType;
    // }
  }

  getDerivedFeeType(feeType: string) {
    if (!this.compData && feeType === 'Standard') return 'Non-Member';
    else if (!this.compData) return feeType;
    if (feeType === 'Standard') return 'Non-Member';
    else if (feeType?.toLowerCase().includes('club'))
      return this.compData?.club?.tag + ' Member (Club)';
    else if (feeType?.toLowerCase().includes('organizer'))
      return (
        (this.compData?.organizer?.shortName || this.compData?.organizer?.name) +
        ' Member (Organizer)'
      );
  }

  async onClickMatchplayNonDetailedScoring() {
    console.debug(
      'on comp scoring click',
      this.currentRound,
      this.details,
      this.competition,
      this.gameRound,
      this.getPlayerStatus()
    );
    if (!this.currentRound) return;
    if (!this.compData) return;
    if (this.compData && !this.compId) return;
    if (this.getPlayerStatus() === 'Withdrawn') {
      let _msg = 'You have Withdrawn from the competition. Please go to View Scorecard instead';
      this.onShowMessage('Scorecard', _msg);
      return false;
    }
    if (1) {
      await Promise.all([this.getCompMatches()]);
      // return;
    }

    // let loader = await this.loadingCtl.create({
    //   message: "Getting scorecard. Please wait...",
    //   backdropDismiss: false
    // });
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _competitionId;
    let _isScorer;
    // this.scorecardService.clearScorecard().subscribe((scorecard)=>{

    // });

    let _today = moment().format('YYYY-MM-DD');
    let _startDate = moment(this.competition.startDate).format('YYYY-MM-DD');
    let _endDate = moment(this.competition.endDate).format('YYYY-MM-DD');

    if (_startDate > _today && _endDate < _today) {
      let _msg = 'Competition is not active anymore';

      console.debug('on comp scoring [1] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    } else if (_endDate < _today) {
      let _msg = 'Competition is not active anymore';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      console.debug('on comp scoring [2] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    }

    console.debug('going to matchplay scoring - active match', this.playerMatches);

    if (this.playerMatches?.length === 0) {
      MessageDisplayUtil.showMessageToast(
        'You have no Active Matches, please view Leaderboard page for progress',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    setTimeout(() => {
      let navigationExtras: NavigationExtras = {
        state: {
          // scorecard: scorecard,
          competition: this.competition,
          compData: this.compData,
          playerMatch: this.playerMatches[0],

          // compId: this.compId,
          // currentPlayer: _player,
          // editingScorecard:
          //   _isScorer && _isScorer.length > 0
          //     ? true
          //     : false,
        },
      };
      this.router.navigate(['matchplay-scoring'], navigationExtras);
    }, 500);
  }

  competitionMatches: Array<CompetitionMatch>;
  playerMatches: Array<CompetitionMatch>;
  getCompMatches() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    this.flightService
      .getCompMatches(this.compData?.id, this.currentRound)
      .subscribe((compMatches: Array<CompetitionMatch>) => {
        console.debug('get comp matches', compMatches);

        this.competitionMatches = compMatches;
        let _currentPlayerMatches = compMatches?.filter((cm: CompetitionMatch) => {
          return (
            cm?.participants?.some((p: CompetitionMatchParticipant) => {
              return p?.player?.id === _player?.playerId;
            }) &&
            (cm?.status === 'InProgress' ||
              cm?.status === 'Pending' ||
              cm?.status === 'Completed' ||
              cm?.status === 'Submitted')
          );
        });
        if (_currentPlayerMatches?.length > 0)
          //this.playerMatches = _currentPlayerMatches;
          this.playerMatches = _currentPlayerMatches
            ?.filter((pm: CompetitionMatch) => {
              return pm?.status !== 'Abandoned';
            })
            .sort((a: CompetitionMatch, b: CompetitionMatch) => {
              if (a?.status === 'InProgress' && b?.status === 'Pending') return -1;
              else if (a?.status === 'Pending' && b?.status === 'InProgress') return 1;
              else {
                if (a?.startTime < b?.startTime) return -1;
                else if (a?.startTime > b?.startTime) return 1;
                else return 0;
              }
            });
        console.debug(
          'get comp matches - current player ',
          compMatches,
          _player,
          _currentPlayerMatches,
          this.playerMatches
        );
      });
  }

  goMatchPlayLeaderboard() {
    // this._refreshCompetitionInfo(null);
    if (this.competition.status == 'Upcoming' || this.competition.status == 'Not Started') {
      // let subTitle =
      //   'Competition has not started. Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        '',
        'Competition has not started. Please refresh to view latest competition status.'
      );
      return false;
    }
    if (!this.competition.showLeaderBoard && this.competition.status != 'Completed') {
      // let subTitle =
      //   'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        'Leaderboard',
        'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.'
      );
      return false;
    }
    if (this.currentRound == null) {
      this.currentRound = this.details.roundInProgress;
      if (!this.currentRound) this.currentRound = this.details.nextRound;
    }
    if (this.currentRound != null) {
      let navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          leaderboards: this.leaderBoard,
          leaderboardPlayers: this.leaderBoard.players,
          roundNo: this.currentRound,
          categories: this.details.categories,
          teams: this.competition.teamEvent ? null : null,
          showTeam: this.showTeam,
          compData: this.compData,
        },
      };
      this.router.navigate(['tabs/competition-matchplay-leaderboard'], navigationExtras);
    }
  }

  goCompMatches() {
    // if (this.gameRound.status === 'Pending') {
    //   this._refreshCompetitionInfo(null, 'refreshFlight');
    //   return false;
    // }

    if (this.competitionMatches?.length < 1) {
      let subTitle = 'No matches have been defined for this round'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Matches', subTitle);
      return false;
      /*  let alert = Alert.create({
       title: 'No Flights',
       subTitle: 'There is no flight assigned for this competition',
       buttons: ['OK']
       });
       this.nav.present(alert);*/
    } else {
      this.gameRound = this.details.gameRounds
        .filter((gr: GameRoundInfo, idx: number) => {
          return gr.roundNo == this.currentRound;
        })
        .pop();
      let navigationExtras: NavigationExtras = {
        state: {
          competitionId: this.compId,
          competition: this.competition,
          compId: this.compId,
          roundNo: this.gameRound.roundNo,
          compData: this.compData,
          competitionMatches: this.competitionMatches,
          currentRound: this.currentRound,
        },
      };
      this.router.navigate(['tabs/competition-matches'], navigationExtras);
    }
  }
  goTeamPlayers() {
    if (this.compData?.competitionTeams === null || this.compData?.competitionTeams?.length == 0) {
      let subTitle = 'No teams have been assigned to this competition'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Teams', subTitle);
      return false;
    } else {
      let navigationExtras: NavigationExtras = {
        state: {
          mode: 'matchTeams',
          compData: this.compData,
          compId: this.compData?.id,
          newCompTeams: this.compData?.competitionTeams,
          compTeamPlayers: this.compTeamPlayersList,
        },
      };
      // alert('Navigation Left to set');
      this.router.navigate(['tabs/competition-teams'], navigationExtras);
    }
  }
  compTeamPlayersList: Array<CompetitionTeamPlayerData> = [];
  getCompTeamPlayers() {
    this.flightService
      .getCompTeamPlayers(this.compData?.id)
      .subscribe((compTeamPlayersList: Array<CompetitionTeamPlayerData>) => {
        if (compTeamPlayersList?.length) this.compTeamPlayersList = compTeamPlayersList;
      });
  }

  subShowLeaderboard: Subscription;
  initWebsocketActions() {
    this.subShowLeaderboard = this.websocketActions
      .subscribeTo(SUBSCRIBE_COMP_SHOW_LEADERBOARD)
      .subscribe((data: any) => {
        console.debug('get update scorer : ', data);
        if (data?.competitionId === this.compData?.id) {
          // this.refreshMatchById();
          this.compData.showLeaderBoard = data?.showLeaderboard;
          this.onRefreshClick(null);
        }
      });
  }

  showToggleFullName: boolean = false;
  onToggleFullName() {
    this.showToggleFullName = !this.showToggleFullName;
  }
}
